export default __webpack_public_path__ + "static/media/video_cuboid_after.0b9d87a2.mp4";